import React from 'react'

const frontend = () => {
    return (
        <div>
            <div className='skills__content'>
                <h3 className="skills__title"> Research Interests</h3>
                <div className="skills__box">
                    <div className="skills__group">
                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Computer Vision</h3>
                                <span className="skills__level">Basic</span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Machine Learning</h3>
                                <span className="skills__level">Advabnce</span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Big Data</h3>
                                <span className="skills__level">Intermediate</span>
                            </div>
                        </div>

                    </div>
                    <div className="skills__group">
                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Robotics Analysis</h3>
                                <span className="skills__level">Intermediate</span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Image Processing</h3>
                                <span className="skills__level">Intermediate</span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>
                            <div>
                                <h3 className="skills__name">Sustainable Technology</h3>
                                <span className="skills__level">Intermediate</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default frontend
